module.exports = __webpack_public_path__ + "img/code.fe3ab968.png";